import React, { useState, useEffect } from 'react';
import { Box, Typography, LinearProgress } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { DotLottieReact } from '@lottiefiles/dotlottie-react';

const TeamsLoader = () => {
  const theme = useTheme();
  const [statusIndex, setStatusIndex] = useState(0);

  const statuses = [
    "LOADING TEAMS DATA",
    "FETCHING CAPABILITIES",
    "SYNCHRONIZING MEMBERS",
    "BUILDING TEAM STRUCTURE",
    "FINALIZING DISPLAY",
  ];

  useEffect(() => {
    const interval = setInterval(() => {
      setStatusIndex((prev) => (prev + 1) % statuses.length);
    }, 3000);

    return () => clearInterval(interval);
  }, []);

  return (
    <Box
      sx={{
        height: '60vh',
        width: '100%',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        bgcolor: 'background.default',
        position: 'relative',
      }}
    >
      {/* ===== LOTTIE ANIMATION ===== */}
      <Box sx={{ width: 300, height: 300, mb: 3 }}>
        <DotLottieReact
          src="https://lottie.host/2c7fe329-f49d-4dbe-a937-1aa2f6396dca/bIG2AKICQe.lottie"
          loop
          autoplay
        />
      </Box>

      {/* ===== TEXT ===== */}
      <Box sx={{ textAlign: 'center', width: '100%', maxWidth: 300 }}>
        <Typography
          sx={{
            fontSize: 14,
            fontWeight: 900,
            letterSpacing: '3px',
            mb: 2,
            textTransform: 'uppercase',
          }}
        >
          Teams Registry
        </Typography>

        <LinearProgress
          sx={{
            height: 2,
            borderRadius: 1,
            bgcolor: '#E2E8F0',
            '& .MuiLinearProgress-bar': {
              bgcolor: 'primary.main',
            },
            mb: 2,
          }}
        />

        <Typography
          sx={{
            fontSize: 10,
            color: 'text.secondary',
            fontWeight: 700,
            letterSpacing: '1px',
          }}
        >
          {statuses[statusIndex]}
        </Typography>
      </Box>

      {/* ===== FOOTER ===== */}
      <Box
        sx={{
          position: 'absolute',
          bottom: 24,
          right: 24,
          opacity: 0.3,
          fontFamily: 'monospace',
          fontSize: 9,
          lineHeight: 1.6,
          textAlign: 'right',
        }}
      >
        MODULE: TEAMS_CORE
        <br />
        STATUS: LOADING
        <br />
        SYNC: ACTIVE
      </Box>
    </Box>
  );
};

export default TeamsLoader;
